import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import NoVideoIcon from '../../assets/icons/vc-no-video.svg?react';
import VideoIcon from '../../assets/icons/vc-video.svg?react';
import { useVideoDevicesOptions } from '../VideoDevicesOptions/useVideoDevicesOptions';
import { VideoDevicesOptions } from '../VideoDevicesOptions/VideoDevicesOptions';
import { MeetControl, MeetControlProps } from './MeetControl';

export function CamControl({
	disabled = false,
	$off = false,
	$withMenu = false,
	vMenuPadding = 0,
	onClick
}: MeetControlProps) {
	const theme = useThemeContext();

	const {
		opened: openedVideoInputDevices,
		open: openVideoInputDevices,
		close: closeVideoInputDevices,
	} = useVideoDevicesOptions();

	return (
		<MeetControl
			disabled={disabled}
			$off={$off}
			$withMenu={$withMenu}
			$menuOpened={openedVideoInputDevices}
			openMenu={openVideoInputDevices}
			closeMenu={closeVideoInputDevices}
			menu={<VideoDevicesOptions />}
			vMenuPadding={vMenuPadding}
			color={theme.colors.neutral[100]}
			onClick={onClick}
			triggerDataTest="video-devices-selector__trigger"
		>
			{$off || disabled ? (
				<NoVideoIcon fill={'#ED576B'} width={20} height={20} />
			) : (
				<VideoIcon fill={$withMenu ? theme.colors.brand.primary[300] : theme.colors.neutral[500]} />
			)}
		</MeetControl>
	);
}
